<template>
  <div class="page-container">
    <PageHeader title="操作日志" show-breadcrumb />

    <SearchPanel>
      <el-input v-model.trim="query.logUserName" placeholder="操作人" clearable size="small" @keyup.enter.native="handleSearch" />
      <el-input v-model.trim="query.logUserId" placeholder="用户ID" clearable size="small" @keyup.enter.native="handleSearch" />
      <el-input v-model.trim="query.logApi" placeholder="接口名" clearable size="small" @keyup.enter.native="handleSearch" />
      <el-select v-model="query.logType" placeholder="操作类型" clearable size="small">
        <el-option label="查询" :value="1" />
        <el-option label="新增" :value="2" />
        <el-option label="编辑" :value="3" />
        <el-option label="删除" :value="4" />
      </el-select>
      <el-select v-model="query.logPlatform" placeholder="登录端" clearable size="small">
        <el-option label="PC端" :value="1" />
        <el-option label="微信端" :value="2" />
      </el-select>
      <template #actions>
        <el-button type="primary" icon="el-icon-search" size="small" @click="handleSearch">查询</el-button>
        <el-button icon="el-icon-refresh" size="small" @click="handleReset">重置</el-button>
      </template>
    </SearchPanel>

    <TablePanel title="日志列表">
      <el-table :data="list" v-loading="loading" size="small" stripe border>
        <el-table-column type="index" label="序号" width="80" align="center" />
        <el-table-column prop="logPlatform" label="平台" width="90" align="center">
          <template slot-scope="{ row }">{{ row.logPlatform === 1 ? 'PC' : '微信' }}</template>
        </el-table-column>
        <el-table-column prop="logUserName" label="操作人" width="110" />
        <el-table-column prop="logType" label="操作类型" width="120" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="logTypeTag(row.logType)" size="mini">{{ logTypeText(row.logType) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="logApi" label="接口名" min-width="180" show-overflow-tooltip />
        <el-table-column prop="logPath" label="接口地址" min-width="220" show-overflow-tooltip />
        <el-table-column prop="description" label="请求描述" width="140" show-overflow-tooltip />
        <el-table-column prop="logMethod" label="请求方式" width="120" align="center" />
        <el-table-column prop="logIp" label="IP地址" width="140" />
        <el-table-column prop="logRequestTime" label="耗时(ms)" width="120" align="center">
          <template slot-scope="{ row }">
            <span :class="{ 'text-danger': row.logRequestTime > 1000 }">{{ row.logRequestTime }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="logParams" label="请求参数" min-width="220" show-overflow-tooltip />
        <el-table-column prop="logUserId" label="用户ID" width="90" align="center" />
        <el-table-column prop="logTime" label="操作时间" width="180" />
      </el-table>
      <el-pagination
        :current-page="page.currentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="page.pageSize"
        :total="page.total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
      />
    </TablePanel>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader.vue'
import SearchPanel from '@/components/SearchPanel.vue'
import TablePanel from '@/components/TablePanel.vue'
import { getSysLogList } from '@/api/api'

export default {
  name: 'LogList',
  components: { PageHeader, SearchPanel, TablePanel },
  data () {
    return {
      loading: false,
      list: [],
      query: { logUserName: '', logUserId: '', logApi: '', logType: null, logPlatform: null },
      page: { currentPage: 1, pageSize: 10, total: 0 }
    }
  },
  created () { this.fetchList() },
  methods: {
    async fetchList () {
      this.loading = true
      try {
        const res = await getSysLogList({ ...this.query, currentPage: this.page.currentPage, pageSize: this.page.pageSize })
        this.list = res.data || []
        this.page.total = res.total || 0
      } catch (e) { this.list = []; this.page.total = 0 } finally { this.loading = false }
    },
    handleSearch () { this.page.currentPage = 1; this.fetchList() },
    handleReset () { this.query = { logUserName: '', logUserId: '', logApi: '', logType: null, logPlatform: null }; this.handleSearch() },
    handleSizeChange (size) { this.page.pageSize = size; this.handleSearch() },
    handlePageChange (page) { this.page.currentPage = page; this.fetchList() },
    logTypeText (v) { return v === 1 ? '查询' : v === 2 ? '新增' : v === 3 ? '编辑' : v === 4 ? '删除' : '其他' },
    logTypeTag (v) { return v === 1 ? '' : v === 2 ? 'success' : v === 3 ? 'warning' : v === 4 ? 'danger' : 'info' }
  }
}
</script>
